import React from "react";
import { ThemeProvider as NextThemeProvider, useTheme } from "next-themes";

export function ThemeProvider({ children }) {
  return (
    <NextThemeProvider attribute="class" defaultTheme="light" enableSystem={false}
      storageKey="gz-theme" disableTransitionOnChange>
      {children}
    </NextThemeProvider>
  );
}

export { useTheme };
